export const environment = {
  production: true,
  FRONTEND_BASE_URL: "https://portal.unilag.edu.ng/isl/",
  BASE_URL: "https://portalapi.unilag.edu.ng",
  TRANZGATE_URL: "https://pay.tranzgate.com.ng/",

  logo: "/assets/logos/isl-logo.png",
  short_name: "ISL",
  long_name: "International School, University of Lagos", 

  nav_links: {
    home: true,
    biodata: true,
    payment: true,
    course: true,
    result: true,
    appointment: true,
    election: true,
    accommodation: true,
    application: true,
    purchases: true,
  },

  remita: true,
  allowedCompanies: [] as string[],
};
